var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPodcast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 135,
    viewBox: "0 0 172 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.3436 126.957V115.033H90.4452V126.957H81.3436Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7604 130.516V130.515C71.7604 128.55 73.9598 126.956 76.6736 126.956H95.5332C98.2469 126.956 100.446 128.55 100.446 130.515V130.516C100.446 132.482 98.2469 134.076 95.5332 134.076H76.6736C73.9598 134.076 71.7604 132.482 71.7604 130.516Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.714 111.677C83.0951 111.677 80.9838 109.558 80.9838 106.946C80.9838 104.336 83.0951 102.216 85.714 102.216C88.3257 102.216 90.4452 104.336 90.4452 106.946C90.4452 109.558 88.3257 111.677 85.714 111.677ZM97.8125 53.7956H111.127C111.679 53.7956 112.127 53.3479 112.127 52.7956V51.4685C112.127 44.1782 109.17 37.5697 104.388 32.795C99.6138 28.013 93.0134 25.0568 85.714 25.0568C71.1253 25.0568 59.2942 36.8798 59.2942 51.4685V52.7956C59.2942 53.3479 59.7419 53.7956 60.2942 53.7956H73.6073C74.4169 53.7956 75.1412 54.1228 75.6751 54.6486C76.2009 55.1826 76.5282 55.916 76.5282 56.7164C76.5282 58.3364 75.2182 59.6382 73.6073 59.6382H60.2942C59.7419 59.6382 59.2942 60.0859 59.2942 60.6382V64.3429C59.2942 64.8952 59.7419 65.3429 60.2942 65.3429H73.6073C74.4169 65.3429 75.1412 65.6702 75.6751 66.196C76.2009 66.7299 76.5282 67.4624 76.5282 68.2638C76.5282 69.8837 75.2182 71.1937 73.6073 71.1937H60.2942C59.7419 71.1937 59.2942 71.6414 59.2942 72.1937V75.8894C59.2942 76.4416 59.7419 76.8894 60.2942 76.8894H73.6073C74.4169 76.8894 75.1412 77.2175 75.6751 77.7515C76.2009 78.2773 76.5282 79.0097 76.5282 79.8193C76.5282 81.4311 75.2182 82.741 73.6073 82.741H60.2942C59.7419 82.741 59.2942 83.1887 59.2942 83.741V87.4458C59.2942 87.9981 59.7419 88.4458 60.2942 88.4458H73.6073C74.4169 88.4458 75.1412 88.773 75.6751 89.2988C76.2009 89.8246 76.5282 90.5562 76.5282 91.3666C76.5282 92.9784 75.2182 94.2884 73.6073 94.2884H59.3803C59.3327 94.2884 59.2942 94.3269 59.2942 94.3745V94.3745C59.2942 108.963 71.1253 120.786 85.714 120.786C100.304 120.786 112.127 108.963 112.127 94.3745V94.3745C112.127 94.3269 112.088 94.2884 112.041 94.2884H97.8125C97.0121 94.2884 96.2796 93.9602 95.7447 93.4353C95.219 92.9004 94.8917 92.1771 94.8917 91.3666C94.8917 89.7467 96.2016 88.4458 97.8125 88.4458H111.127C111.679 88.4458 112.127 87.9981 112.127 87.4458V83.741C112.127 83.1887 111.679 82.741 111.127 82.741H97.8125C97.0121 82.741 96.2796 82.4128 95.7447 81.888C95.219 81.354 94.8917 80.6297 94.8917 79.8193C94.8917 78.2002 96.2016 76.8894 97.8125 76.8894H111.127C111.679 76.8894 112.127 76.4416 112.127 75.8894V72.1937C112.127 71.6414 111.679 71.1937 111.127 71.1937H97.8125C97.0121 71.1937 96.2796 70.8664 95.7447 70.3406C95.219 69.8067 94.8917 69.0742 94.8917 68.2638C94.8917 66.6529 96.2016 65.3429 97.8125 65.3429H111.127C111.679 65.3429 112.127 64.8952 112.127 64.3429V60.6382C112.127 60.0859 111.679 59.6382 111.127 59.6382H97.8125C97.0121 59.6382 96.2796 59.3109 95.7447 58.7851C95.219 58.2593 94.8917 57.5269 94.8917 56.7164C94.8917 55.1055 96.2016 53.7956 97.8125 53.7956Z",
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0046 95.0107C41.178 95.0107 39.6976 93.5304 39.6976 91.7037V54.1399C39.6976 52.3124 41.178 50.832 43.0046 50.832C44.8322 50.832 46.3134 52.3124 46.3134 54.1399V91.7037C46.3134 93.5304 44.8322 95.0107 43.0046 95.0107Z",
    fill: "url(#paint0_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7731 88.4561C27.9455 88.4561 26.4642 86.9748 26.4642 85.1481V60.6937C26.4642 58.867 27.9455 57.3858 29.7731 57.3858C31.5997 57.3858 33.081 58.867 33.081 60.6937V85.1481C33.081 86.9748 31.5997 88.4561 29.7731 88.4561Z",
    fill: "url(#paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5405 83.3579C14.7129 83.3579 13.2325 81.8766 13.2325 80.05V65.793C13.2325 63.9655 14.7129 62.4842 16.5405 62.4842C18.3671 62.4842 19.8484 63.9655 19.8484 65.793V80.05C19.8484 81.8766 18.3671 83.3579 16.5405 83.3579Z",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4634 71.6757V80.7891C26.4634 79.8717 26.0972 79.0458 25.4971 78.4457C24.8969 77.8528 24.0638 77.4784 23.1537 77.4784C21.3243 77.4784 19.8494 78.9615 19.8494 80.7891V71.6757C19.8494 73.5042 21.3243 74.9864 23.1537 74.9864C24.9812 74.9864 26.4634 73.5042 26.4634 71.6757Z",
    fill: "url(#paint3_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6995 62.2448V71.6763C39.6995 70.7652 39.3315 69.9394 38.7322 69.3402C38.1385 68.74 37.3054 68.372 36.3952 68.372C34.5668 68.372 33.0846 69.8551 33.0846 71.6763V62.2448C33.0846 64.0732 34.5668 65.5554 36.3952 65.5554C38.2237 65.5554 39.6995 64.0732 39.6995 62.2448Z",
    fill: "url(#paint4_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6995 76.0743V85.5059C39.6995 84.5948 39.3315 83.769 38.7322 83.1688C38.1385 82.5687 37.3054 82.2016 36.3952 82.2016C34.5668 82.2016 33.0846 83.6837 33.0846 85.5059V76.0743C33.0846 77.9019 34.5668 79.385 36.3952 79.385C38.2237 79.385 39.6995 77.9019 39.6995 76.0743",
    fill: "url(#paint5_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30792 78.0146C1.48036 78.0146 0 76.5334 0 74.7067V71.1359C0 69.3083 1.48036 67.8271 3.30792 67.8271C5.13457 67.8271 6.61584 69.3083 6.61584 71.1359V74.7067C6.61584 76.5334 5.13457 78.0146 3.30792 78.0146Z",
    fill: "url(#paint6_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M128.784 95.0107C130.611 95.0107 132.091 93.5304 132.091 91.7037V54.1399C132.091 52.3124 130.611 50.832 128.784 50.832C126.957 50.832 125.475 52.3124 125.475 54.1399V91.7037C125.475 93.5304 126.957 95.0107 128.784 95.0107Z",
    fill: "url(#paint7_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142.016 88.4561C143.843 88.4561 145.325 86.9748 145.325 85.1481V60.6937C145.325 58.867 143.843 57.3858 142.016 57.3858C140.189 57.3858 138.708 58.867 138.708 60.6937V85.1481C138.708 86.9748 140.189 88.4561 142.016 88.4561Z",
    fill: "url(#paint8_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M155.248 83.3579C157.076 83.3579 158.556 81.8766 158.556 80.05V65.793C158.556 63.9655 157.076 62.4842 155.248 62.4842C153.422 62.4842 151.94 63.9655 151.94 65.793V80.05C151.94 81.8766 153.422 83.3579 155.248 83.3579Z",
    fill: "url(#paint9_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M145.325 71.6757V80.7891C145.325 79.8717 145.692 79.0458 146.292 78.4457C146.892 77.8528 147.725 77.4784 148.635 77.4784C150.465 77.4784 151.939 78.9615 151.939 80.7891V71.6757C151.939 73.5042 150.465 74.9864 148.635 74.9864C146.808 74.9864 145.325 73.5042 145.325 71.6757",
    fill: "url(#paint10_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M132.089 62.2448V71.6763C132.089 70.7652 132.457 69.9394 133.057 69.3402C133.65 68.74 134.483 68.372 135.394 68.372C137.222 68.372 138.704 69.8551 138.704 71.6763V62.2448C138.704 64.0732 137.222 65.5554 135.394 65.5554C133.565 65.5554 132.089 64.0732 132.089 62.2448",
    fill: "url(#paint11_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.089 76.0743V85.5059C132.089 84.5948 132.457 83.769 133.057 83.1688C133.65 82.5687 134.483 82.2016 135.394 82.2016C137.222 82.2016 138.704 83.6837 138.704 85.5059V76.0743C138.704 77.9019 137.222 79.385 135.394 79.385C133.565 79.385 132.089 77.9019 132.089 76.0743",
    fill: "url(#paint12_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M168.481 78.0146C170.309 78.0146 171.789 76.5334 171.789 74.7067V71.1359C171.789 69.3083 170.309 67.8271 168.481 67.8271C166.654 67.8271 165.173 69.3083 165.173 71.1359V74.7067C165.173 76.5334 166.654 78.0146 168.481 78.0146Z",
    fill: "url(#paint13_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M145.322 59.4274C145.322 60.9947 145.258 62.5413 145.144 64.0806H138.498C138.632 62.5485 138.703 60.9947 138.703 59.4274C138.703 38.1657 126.14 19.842 108.036 11.4712L107.92 11.7848C107.245 13.636 105.186 14.5787 103.345 13.8726C97.9287 11.7948 92.0436 10.6553 85.8946 10.6553C79.7456 10.6553 73.8604 11.7948 68.4439 13.8726C66.6028 14.5787 64.544 13.636 63.8687 11.7848L63.7536 11.4712C45.6493 19.842 33.0866 38.1657 33.0866 59.4274C33.0866 60.9947 33.1573 62.5485 33.2915 64.0806H26.6448C26.5315 62.5413 26.4672 60.9947 26.4672 59.4274C26.4672 26.6029 53.0701 -2.34081e-05 85.8946 -2.34081e-05C118.719 -2.34081e-05 145.322 26.6029 145.322 59.4274",
    fill: "url(#paint14_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 48.6731,
    y1: 72.9214,
    x2: 0.198748,
    y2: 72.9214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 48.6732,
    y1: 72.9209,
    x2: 0.198715,
    y2: 72.9209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 48.6732,
    y1: 72.9211,
    x2: 0.198695,
    y2: 72.9211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 48.6735,
    y1: 76.2328,
    x2: 0.198639,
    y2: 76.2328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 48.6732,
    y1: 66.9605,
    x2: 0.198755,
    y2: 66.9605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 48.6732,
    y1: 80.7901,
    x2: 0.198755,
    y2: 80.7901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 48.6733,
    y1: 72.9209,
    x2: 0.198709,
    y2: 72.9209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 123.116,
    y1: 72.9214,
    x2: 171.59,
    y2: 72.9214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 123.116,
    y1: 72.9209,
    x2: 171.59,
    y2: 72.9209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 123.115,
    y1: 72.9211,
    x2: 171.59,
    y2: 72.9211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 123.116,
    y1: 76.2328,
    x2: 171.59,
    y2: 76.2328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 123.116,
    y1: 66.9605,
    x2: 171.59,
    y2: 66.9605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 123.116,
    y1: 80.7901,
    x2: 171.59,
    y2: 80.7901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 123.116,
    y1: 72.9209,
    x2: 171.59,
    y2: 72.9209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 85.8946,
    y1: 98.5404,
    x2: 85.8946,
    y2: 1.61269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcast);
export default __webpack_public_path__ + "static/media/podcast.2dc341ed53fc4fe1acc4677235c6bb88.svg";
export { ForwardRef as ReactComponent };